import React from 'react';
import styled, {keyframes} from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Icon } from '@iconify/react';
import rocketIcon from '@iconify/icons-mdi/rocket';
const TourToggle = (tourType, props) => {
    props.dispatch({ type: `set${tourType}Tour`, [`is${tourType}TourActive`]: true })
}
const Component = (props) => {
    const { location:{ pathname }, messages, tour } = props
    const TourList = ["InfoList", "Info"]
    const tourType = pathname.split("/")[1]
    const isShown = TourList.includes(tourType)
    const isActive= tour[`is${tourType}TourActive`]
    return (
        <TourButton 
            id="ga_user_tour"
            isShown={isShown}
            isActive={isActive}
            onClick={() => TourToggle(tourType, props)}>
            <Icon icon={rocketIcon} color={isActive ? "#fff" : "#999"} width="1.2em" height="1.2em"/>
            {messages.user_tour}
        </TourButton>
    )
}
const mapStateToProps = state => {
    return {
        tour: state.Tour,
        messages: state.Messages
    }
}
export default withRouter(connect(mapStateToProps)(Component));
const shine = keyframes`
    0% { top: -100px; left: -280px; }
    100% { top: 100%; left: 100%; }
`
const TourButton = styled.div`
    position: relative;
	display: ${({isShown}) => isShown ? "flex" : 'none'};
	align-items:center;
	justify-content: center;
	padding: 3px 10px;
	border: ${({ isActive }) => isActive ? "1px solid #e94242" : "1px solid #999"};
	border-radius: 3px;
	background-color: ${({ isActive }) => isActive ? "#e94242" : "#fff"};
	color: ${({ isActive }) => isActive ? "#fff" : "#999"};
	margin-right: 32px;
    font-size: 14px;
	font-weight: 300;
    cursor: pointer;
    overflow: hidden;
    &:before {
        position: absolute;
        display: ${({ isActive }) => isActive ? "block" : "none"};
        top: 0;
        left: 0;
        content: "";
        height: 20px;
        width: 200px;
        background: rgba(255,255,255,0.10);
        transform: rotate(-20deg);
        animation-name: ${shine};
        animation-duration: 2s;
        animation-timing-function: cubic-beizer(.17,.79,.96,.25);
        animation-iteration-count: infinite;
    }
	@media(max-width: 667px) {
		display: none;
	}
`


// WEBPACK FOOTER //
// ./src/Tour/TourButton.js